<template>
  <div class="banner">
      <div class="titulo text-white">
          <h2 class="text-white" style="font-size:50px">Crea una Cuenta</h2>
      </div>
  </div>

  <div class="crear-cuenta-page">
    <div class="row">
      <div class="col-xs-12 block-top-title">
          <img src="@/assets/img/agv_logo.jpg" class="img-fluid" alt="Logo" style="width:60px"/>
          <div>
            <h5>Base general </h5>
            <small>Completa tu cv para futuras búsquedas </small>
          </div>
      </div>
      <div class="col-xs-12">
        <ul class="nav nav-tabs nav-justified">
          <li class="nav-item">
            <a
              class="nav-link active"
              href="#tab-datospersonales"
              data-bs-toggle="tab"
              >
                <span class="nav-tab-span">Datos Personales</span>
              </a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#tab-informacionadicional" data-bs-toggle="tab">
              <span class="nav-tab-span">Información Adicional</span>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane show active" id="tab-datospersonales">
            <small class="lbl-camposobligatorios">Campos obligatorios <span class="text-danger">*</span></small>
            <div class="row">
              <div class="col-sm-2">
                  <p><strong>Foto <span class="text-danger">*</span></strong></p>
                  <div class="avatar avatar-xxl me-1">
                    <img
                      class="avatar-img rounded-circle"
                      alt="User Image"
                      src="@/assets/admin_img/profiles/avatar-02.jpg"
                    />
                  </div>
              </div>
              <div class="col-sm-10">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Nombre <span class="text-danger">*</span></label>
                      <input type="text" placeholder="Ingresar tu nombre" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Apellido <span class="text-danger">*</span></label>
                      <input type="text" placeholder="Ingresar tu apellido"  class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Email <span class="text-danger">*</span></label>
                      <input type="text" placeholder="Ingresa tu email"  class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Confirmar email <span class="text-danger">*</span></label>
                      <input type="text" placeholder="Ingresa tu email"  class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Tipo de de Documento <span class="text-danger">*</span></label>
                       <select class="form-control" required >
                            <option value="">Seleccione una opción</option>
                            <option value="D">DNI</option>
                            <option value="C">CE</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">N° de Documento <span class="text-danger">*</span></label>
                        <input type="text" placeholder="XX XXX XXX" class="form-control" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Teléfono <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" placeholder="XX XXX XXXX"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="font-bold">Tipo de Teléfono <span class="text-danger">*</span></label>
                      <select class="form-control" required>
                            <option value="">Seleccione una opción</option>
                            <option value="T">Tél. Fijo</option>
                            <option value="C">Celular</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">Género <span class="text-danger">*</span></label>
                        <select class="form-control" required>
                            <option value="">Seleccione una opción</option>
                            <option value="M">Masculino</option>
                            <option value="F">Femenino</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">Nacionalidad <span class="text-danger">*</span></label>
                        <select class="form-control" required>
                            <option value="">Seleccione una opción</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">País de Residencia <span class="text-danger">*</span></label>
                        <select class="form-control" required>
                            <option value="">Seleccione una opción</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">Provincia </label>
                        <select class="form-control" disabled >
                            <option value="">Seleccione una opción</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">Localidad </label>
                        <select class="form-control" disabled >
                            <option value="">Seleccione una opción</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                        <label class="font-bold">Fecha de nacimiento <span class="text-danger">*</span></label>
                        <div class="row">
                          <div class="col-sm-4">
                            <select class="form-control" required placeholder="Día">
                              <option value="">Día</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                          </div>
                          <div class="col-sm-4">
                            <select class="form-control" required placeholder="Mes">
                              <option value="">Mes</option>
                              <option value="1">Enero</option>
                              <option value="2">Febrero</option>
                              <option value="3">Marzo</option>
                              <option value="4">Abril</option>
                              <option value="5">Mayo</option>
                              <option value="6">Junio</option>
                            </select>
                          </div>
                          <div class="col-sm-4">
                            <select class="form-control" required placeholder="Año">
                              <option value="">Año</option>
                              <option value="1990">1990</option>
                              <option value="1991">1991</option>
                              <option value="1992">1992</option>
                              <option value="1993">1993</option>
                              <option value="1994">1994</option>
                              <option value="1995">1995</option>
                              <option value="1996">1996</option>
                            </select>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="tab-informacionadicional">
              <small class="lbl-camposobligatorios">Campos obligatorios <span class="text-danger">*</span></small>
              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Educación </h6>
                    <hr />
                    <h6 class="font-bold btn-anadir">+ Añadir Educación </h6>
                    <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">¿Tienes los estudios secundarios completos? </h6>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="estudios_completos"
                        id="estudios_completos_si"
                        value="1"
                      />
                      <label class="form-check-label" for="estudios_completos_si">
                        SÍ
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="estudios_completos"
                        id="estudios_completos_no"
                        value="0"
                      />
                      <label class="form-check-label" for="estudios_completos_no">
                        NO
                      </label>
                    </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Idiomas </h6>
                    <hr />
                    <h6 class="font-bold btn-anadir">+ Añadir Idioma </h6>
                    <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Experiencia laboral </h6>
                    <hr />
                    <h6 class="font-bold btn-anadir">+ Añadir experiencia </h6>
                    <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Redes</h6>
                    <hr />
                    <div class="row">
                      <div class="col-xs-12 col-sm-6">
                        <div class="form-group">
                          <label class="font-bold">LinkedIn</label>
                          <input type="text" placeholder="Ej. https://pe.linkedin.com/in/juan-perez"  class="form-control" />
                        </div>
                      </div>
                    </div>
                    <h6 class="font-bold btn-anadir">+ Añadir otra red social </h6>
                    <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Currículum</h6>
                    <hr />
                    <p class="font-bold">Adjuntar archvio desde:</p>
                    <div class="row">
                      <div class="col-sm-3">
                        <button  type="button" class="btn btn-block btn-subirarchivos">
                            <img  src="@/assets/img/icon/icons8-home-40.png"/>
                            <span>Mis Archivos</span>
                        </button>
                      </div>
                      <div class="col-sm-3">
                        <button  type="button" class="btn btn-block btn-subirarchivos">
                            <img  src="@/assets/img/icon/icons8-dropbox-48.png"/>
                            <span>Dropbox</span>
                        </button>
                      </div>
                      <div class="col-sm-3">
                        <button  type="button" class="btn btn-block btn-subirarchivos">
                            <img  src="@/assets/img/icon/icons8-google-drive-48.png"/>
                            <span>Google Drive</span>
                        </button>
                      </div>
                    </div>
                    <p class="txt-tamañomax">Tamaño máx: 15MB Formato: pdf o .doc o .docx</p>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <h6 class="font-bold">Expectativas personales</h6>
                    <hr />
                    <h6 class="font-bold btn-anadir">+ Añadir mensaje adicional </h6>
                    <hr />
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <div class="checkbox">
                      <label> <input type="checkbox" checked class="chk-terminos form-check-input" name="checkbox" /> Me interesaría recibir invitación para cargar mi perfil en Agrovision.com</label>
                    </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                    <div class="checkbox">
                      <label> <input type="checkbox" class="chk-terminos form-check-input" name="checkbox" /> He leído y acepto los <span class="lbl-resaltado">Términos y Condiciones</span> y las <span class="lbl-resaltado">Políticas de privacidad</span></label>
                    </div>
                </div>
              </div>

              <div class="blk-botonera-derecha">
                <button class="btn-outline-action"> <i class="fa fa-arrow-left"></i> Anterior </button>
                <button clasS="btn-action"> Registrarse </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .banner, .banner::after{
    height: 200px;
  }

  .banner .titulo {
    top: 100px;
  }

  .crear-cuenta-page {
     padding: 16px 48px;
  }

  .nav-tabs.nav-tabs-bottom > li > a.active, .nav-tabs.nav-tabs-bottom > li > a.active:hover, .nav-tabs.nav-tabs-bottom > li > a.active:focus {
    border-bottom-color: #23ba71 !important;
  }

  .chat-cont-left .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #23ba71 !important;
  }

  .block-top-title{
    display: flex;
    gap: 16px;
    flex-wrap: nowrap;
    align-items: center;
    color: #535151;
  }

  .block-top-title h4, .block-top-title h5{
    color: #535151;
  }

  .nav-link.active .nav-tab-span {
    padding: 8px;
    border-bottom: 4px solid #23ba71 !important;
  }

  .nav-tabs .nav-link{
    border: 0 !important;
  }

  .form-group{
    margin-bottom: 16px;
  }

  ::placeholder {
    color: gray !important;
  }

  select:invalid { color: gray; }
  
  .lbl-camposobligatorios{
    position: absolute;
    right: 114px;
    font-size: .7em;
    color: gray;
  }

  .tab-pane{
    padding: 0px 64px;
  }

  .btn-anadir{
    color: #23ba71;
    cursor: pointer;
  }

  .txt-tamañomax{
    margin-top: 16px;
    color:gray;
    font-size:0.9em;
  }

  .btn-subirarchivos{
    display: flex !important;
    gap: 16px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .btn-subirarchivos img {
    width: 30px;
  }

  .blk-botonera-derecha{
    margin-top: 24px;
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: flex-end;
  }

  .btn-outline-action {
    color: #23ba71;
    border-color: #23ba71;
    background-color: white;
    padding: 11px 24px;
    border-radius: 6px;
    transition: all 0.5s;
    font-weight: 600;
  }

  .btn-action {
    background-color: #23ba71;
    border: 1px solid #23ba71;
    color:white;
    padding: 11px 24px;
    border-radius: 6px;
    transition: all 0.5s;
    font-weight: 600;
  }

  .lbl-resaltado {
    font-weight: bold;
    color: #23ba71;
  }

  .chk-terminos{
    margin-right: 16px;
  }

  .form-check-input:checked {
    background-color: #23ba71 !important;
    border-color: #23ba71 !important;
  }
</style>

<script>
import { Form, Field } from "vee-validate";
import { router } from "@/router";
import * as Yup from "yup";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      activeTab: "developer",
      showPassword: false,
      showPassword1: false,
      password: null,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    buttonLabel() {
      return this.showPassword1 ? "Hide" : "Show";
    },
  },
  methods: {
    activateTab(tab) {
      this.activeTab = tab;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
  },
  mounted() {},
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmpassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Confirm password is required"),
    });
    const onSubmit = (values) => {
      if (values.password === values.confirmpassword) {
        let Rawdata = localStorage.getItem("storedData");
        let Pdata = [];
        Pdata = JSON.parse(Rawdata);
        const Eresult = Pdata.find(({ email }) => email == values.email);
        if (Eresult) {
          document.getElementById("email").innerHTML = "This email are already exist";
        } else {
          Pdata.push(values);
          const jsonData = JSON.stringify(Pdata);
          router.push("/");
          localStorage.setItem("storedData", jsonData);
        }
      } else {
        document.getElementById("confirmpassword").innerHTML = "Password not matching";
      }
    };
    return {
      schema,
      onSubmit,
    };
  },
};
</script>
